import React from 'react';

export interface ScorecardsContextType {
  // Active (non-archived) scorecards. Does not include scorecards with isHidden: true.
  scorecards: Scorecards.Scorecard[];
  // Scorecards with isHidden: true. Only exposed for the staff-only Archived view.
  archivedScorecards: Scorecards.Scorecard[];
  scorecardsLookup: { [id: string]: Scorecards.Scorecard | undefined };
  isLoading: boolean;
}

const ScorecardsContext = React.createContext<ScorecardsContextType>({
  scorecards: [],
  archivedScorecards: [],
  scorecardsLookup: {},
  isLoading: false,
});

export default ScorecardsContext;
